(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.MedicarePlanning",
                {
                    url: "/MedicarePlanning",
                    component: "medicarePlanning",
                    PageTitle: "Medicare Planning",
                    requiredPermissions: "MedicarePlanning:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("medicarePlanning",
        {
            templateUrl: "App/Resources/MedicarePlanning/medicare-planning.template.html",
            controller: medicarePlanningCtrl,
            bindings: {
                states: "<"
            }
        });

    medicarePlanningCtrl.$inject = ["amplitudeService"];

    function medicarePlanningCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
       
    }
})(window.app, window.angular); // jshint ignore:line